import { FC } from 'react';
import { LoadingFrame } from '@synqo/frontend-component-library';
import { useGetDocumentsPlaceholders } from '@Hooks/Documents/useGetDocumentsPlaceholders';
import { Placeholders } from '@Components/Placeholders';
import { EnumPlaceholderKinds } from '@Model';

export const DocumentsPlaceholders: FC<{ placeholdersKind: EnumPlaceholderKinds }> = ({ placeholdersKind }) => {
    const { placeholders, isLoading } = useGetDocumentsPlaceholders(placeholdersKind);

    if (isLoading) {
        return <LoadingFrame />;
    }

    return <Placeholders placeholders={placeholders} />;
};
